import React from 'react'
import { makeStyles } from '@material-ui/styles'
import { Hidden, Grid } from '@material-ui/core'
import { DocumentationOnboardSidebar } from './components'
import { useIsMobileScreen } from '~/hooks'

const useStyles = makeStyles({
  container: {
    flexGrow: 1,
    backgroundColor: '#F8F8F8'
  }
})

export const DocumentationOnboardLayout: React.FC = (props) => {
  const { children } = props
  const classes = useStyles()
  const isMobile = useIsMobileScreen()

  return (
    <Grid className={classes.container} container spacing={0}>
      <Hidden mdDown>
        <Grid item xs={3}>
          <DocumentationOnboardSidebar />
        </Grid>
      </Hidden>
      <Grid item xs={isMobile ? 12 : 9 }>
        {children}
      </Grid>
    </Grid >
  )
}
